import {
  RegimeValues,
  DriedVegetablesValues,
  FishFrequencyValues,
  FruitsValues,
  MeatFrequencyValues,
  MomentValues,
  StarchyFoodsValues,
  StructureValues,
  SugarFrequencyValues,
} from 'src/types'

export const planRegimeValues = (
  onboardingRegimeValues: RegimeValues
): RegimeValues => onboardingRegimeValues || RegimeValues.NONE

export const planStructure = (
  onboardingStructure: StructureValues
): StructureValues => onboardingStructure || StructureValues.ENT_PLAT

export const planExpress = (onboardingExpress: boolean): boolean => {
  return onboardingExpress || false
}

export const planMoment = (onboardingMoment: string): string => {
  return onboardingMoment || MomentValues.LUNCH_AND_DINNER
}

export const planFruitAndVegetable = (
  onboardingFruitAndVegetable: FruitsValues
): FruitsValues => onboardingFruitAndVegetable || FruitsValues.PORTIONS_3

export const planCompleteCarbohydrate = (
  onboardingCompleteCarbohydrate: StarchyFoodsValues
): StarchyFoodsValues =>
  onboardingCompleteCarbohydrate || StarchyFoodsValues.PER_WEEK_1

export const planDriedVegetable = (
  onboardingDriedVegetable: DriedVegetablesValues
): DriedVegetablesValues =>
  onboardingDriedVegetable || DriedVegetablesValues.RARELY

export const planMeat = (
  onboardingMeat: MeatFrequencyValues
): MeatFrequencyValues => onboardingMeat || MeatFrequencyValues.PER_WEEK_5

export const planFish = (
  onboardingFish: FishFrequencyValues
): FishFrequencyValues => onboardingFish || FishFrequencyValues.RARELY

export const planSugaryProduct = (
  onboardingSugaryProduct: SugarFrequencyValues
): SugarFrequencyValues =>
  onboardingSugaryProduct || SugarFrequencyValues.PER_DAY_2
